import { createQueryString } from '../Api'

const INITIAL_STATE = {
  all: [],
  attributes: {},
  current: null,
}

export default {
  namespaced: true,
  state: {
    ...INITIAL_STATE,
  },
  getters: {
    find: (state) => (id) => state.find(el => el.id === id),
  },
  mutations: {
    setCurrent: (state, { item }) => {
      state.current = item
    },
    setAttributes: (state, attributes) => {
      state.attributes = attributes
    },
    add: (state, { item, prepend = false }) => {
      if (prepend) {
        state.all.unshift(item)
      } else {
        state.all.push(item)
      }
    },
    remove: (state, { id }) => {
      let idx = state.all.findIndex(el => el.id === id)
      state.all.splice(idx, 1)
    },
    reset: (state) => {
      state.all = []
    },
  },
  actions: {
    all: (
      { dispatch, rootGetters, commit },
      { last_update, filter = {}, limit = {}, language = undefined } = {}) => {
      let headers = {
        'Content-Type': 'application/json',
      }
      Object.assign(headers, rootGetters['Api/getAuthHeader'])
      
      let actionPath = '/api/converters/all.json'
      let query = createQueryString({ last_update, filter, limit, language })
      if (query) {
        actionPath = [actionPath, query].join('?')
      }
      
      return dispatch('Api/apiRequest', {
        actionPath: actionPath,
        method: 'get',
        headers: headers,
      }, { root: true }).then(result => {
        
        result.forEach(item => commit('add', { item }))
        
        return Promise.resolve(result)
      })
    },
    attributes: ({ dispatch, rootGetters, commit }) => {
      let headers = {
        // 'Content-Type': 'application/json',
      }
      Object.assign(headers, rootGetters['Api/getAuthHeader'])
      
      return dispatch('Api/apiRequest', {
        actionPath: '/api/converters/attributes.json',
        method: 'get',
        headers: headers,
        
      }, { root: true }).then(result => {
        
        commit('setAttributes', result)
        
        return Promise.resolve(result)
      })
    },
    get: ({ dispatch, rootGetters, commit }, { id }) => {
      let headers = {
        'Content-Type': 'application/json',
      }
      Object.assign(headers, rootGetters['Api/getAuthHeader'])
      
      return dispatch('Api/apiRequest', {
        actionPath: ['/api/converters/get/', id, '.json'].join(''),
        method: 'get',
        headers: headers,
        
      }, { root: true }).then(result => {
        
        commit('setCurrent', { item: result })
        
        return Promise.resolve(result)
      })
    },
  },
}
